export default __webpack_public_path__ + "static/media/bg-bottom-pink-gradient.8381307c.svg";